<template>
	<div>

		<v-data-table
			:headers="encabezado"
			:items="fuente.listado"
			item-key="identificador"
			class="elevation-1 mb-16"
			:items-per-page="10000"
			:loading="fuente.listando"
			hide-default-footer
		>
			<template v-slot:item.creación.fecha="{ item }">
				<div v-if="item.creación.fecha">
					{{ new Date(item.creación.fecha.seconds * 1000).toLocaleString('es') }}
				</div>
				<div v-if="item.anulada" class="red--text">
					Anulada
				</div>
			</template>
			<template v-slot:item.fechaDeEmisión="{ item }">
				{{ item.fechaDeEmisión }}
			</template>
			<template v-slot:item.productos="{ item }">
				<ul>
					<li v-for="p in item.productos" :key="`pdcto${p.identificador}`">({{ p.cantidad }}) {{ p.descripción }}</li>
				</ul>
			</template>
			<template v-slot:item.subtotal="{ item }">
				{{ moneda(item.subtotal) }}
			</template>
			<template v-slot:item.total="{ item }">
				{{ moneda(item.total) }}
			</template>
			<template v-slot:item.acciones="{ item }">
				<v-tooltip bottom v-if="!item.anulada">
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-on="on" v-bind="attrs" @click="abrirDiálogoAnulación(item)">
							<v-icon>mdi-cancel</v-icon>
						</v-btn>
					</template>
					<span>Anular factura de venta</span>
				</v-tooltip>
			</template>
		</v-data-table>

		<v-dialog
			v-model="diálogoCreación"
      max-width="800"
			persistent
		>
			<factura-de-venta
				@guardar="diálogoCreación = false"
				@cancelar="diálogoCreación = false"
			></factura-de-venta>
		</v-dialog>

		<v-dialog
			v-model="diálogoAnulación"
      max-width="800"
			persistent
		>
			<v-card>
				<v-card-title class="headline">Anular factura de venta</v-card-title>

				<v-card-text>

					<factura-constructor-tabla ref="tablaFacturaAnulando" :solo-lectura="true"></factura-constructor-tabla>

					<v-alert type="error" class="text-center mt-8">
						¿Está seguro de que quiere anular esta factura de venta?
					</v-alert>

				</v-card-text>

				<v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
						:disabled="fuente.anulando"
            @click="cerrarDiálogoAnulación()"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="red darken-1"
            text
						:loading="fuente.anulando"
            @click="anular"
					>
            Sí, anularla
          </v-btn>
        </v-card-actions>
			</v-card>
		</v-dialog>

		<v-btn
			fixed
			dark
			fab
			bottom
			right
			color="pink"
			@click.stop="diálogoCreación = true"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>

	</div>
</template>

<script>
import { facturasDeVenta } from '@/../../cliente_comun/fuentes'
import { moneda } from '@/../../cliente_comun/utilidades'
import facturaConstructorTabla from '@/../../cliente_comun/factura_constructor_tabla.vue'
import facturaDeVenta from '@/components/facturaDeVenta.vue'

export default {
	name: 'FacturasDeVenta',
  data: () => ({
		fuente: facturasDeVenta,
		encabezado: [
			{ text: 'Fecha de creación', value: 'creación.fecha', sortable: false },
			{ text: 'Fecha de emisión', value: 'fechaDeEmisión', sortable: false },
			{ text: 'Productos', value: 'productos', sortable: false },
			{ text: 'Subtotal', value: 'subtotal', align: 'end', sortable: false },
			{ text: 'Total', value: 'total', align: 'end', sortable: false },
			{ text: '', value: 'acciones', align: 'end', filterable: false, sortable: false },
		],
		diálogoCreación: false,
		diálogoAnulación: false,
		facturaParaAnular: null,
	}),
	components: {
		facturaConstructorTabla,
		facturaDeVenta
	},
	mounted: function() {
		this.fuente.inicializar()
	},
	methods: {
		moneda,
		anular: function() {
			this.fuente.anular(this.facturaParaAnular.identificador).then( rta => {
				this.cerrarDiálogoAnulación()
			}).catch(() => { })
		},
		abrirDiálogoAnulación: function(d) {
			if (!d || !d.productos) {
				window.alert('[5732] Ocurrió un error.')
				return
			}

			this.facturaParaAnular = d
			this.diálogoAnulación = true
			this.$nextTick(() => {
				this.$refs.tablaFacturaAnulando.limpiar()
				for (let p of this.facturaParaAnular.productos) {
					this.$refs.tablaFacturaAnulando.agregarProducto(p, {cantidad: p.cantidad})
				}
			})
		},
		cerrarDiálogoAnulación: function() {
			this.$refs.tablaFacturaAnulando.limpiar()
			this.facturaParaAnular = null
			this.diálogoAnulación = false
		}
	}
}
</script>